import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { searchProducts, clearSearch } from '../store/slices/productsSlice';
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline';
import debounce from 'lodash/debounce';

const ProductSearch = () => {
  const dispatch = useDispatch();
  const [searchInput, setSearchInput] = useState('');
  const { isSearching, totalCount, searchError } = useSelector(state => state.products);

  const debouncedSearch = useCallback(
    debounce((value) => {
      if (value.trim()) {
        dispatch(searchProducts({
          product_name: value,
          page: 1,
          page_size: 20
        }));
      } else {
        dispatch(clearSearch());
      }
    }, 500),
    [dispatch]
  );

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const handleSearch = (value) => {
    setSearchInput(value);
    debouncedSearch(value);
  };

  const handleClear = () => {
    setSearchInput('');
    dispatch(clearSearch());
  };

  return (
    <div className="relative mb-6">
      <div className="relative">
        <input
          type="text"
          value={searchInput}
          onChange={(e) => handleSearch(e.target.value)}
          placeholder="جستجو در محصولات..."
          className="w-full px-4 py-3 pl-10 pr-12 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
        <MagnifyingGlassIcon className="absolute right-4 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
        {isSearching && (
          <div className="absolute left-4 top-1/2 transform -translate-y-1/2">
            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-500"></div>
          </div>
        )}
        {searchInput && !isSearching && (
          <button
            onClick={handleClear}
            className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        )}
      </div>
      {searchError && (
        <div className="mt-2 text-sm text-red-600">
          {typeof searchError === 'object' ? JSON.stringify(searchError) : searchError}
        </div>
      )}
      {searchInput && totalCount > 0 && !searchError && (
        <div className="mt-2 text-sm text-gray-600">
          {totalCount} محصول یافت شد
        </div>
      )}
    </div>
  );
};

export default ProductSearch;
